export default __webpack_public_path__ + "static/Triangle-99f1ad098c900753a22fc41dccecba06.svg";